export const favoriteSessionsArray = [
  {
    title: 'Ball Busting',
    description: 'Experience the ultimate test of endurance under my control.',
    image: '/images/ball-busting.jpg',
  },
  {
    title: 'CBT (Cock and Ball Torture)',
    description: 'Push your limits with precision and discipline.',
    image: '/images/cbt.jpg',
  },
  {
    title: 'Foot Worship',
    description: 'Kneel before Me and show your devotion at my feet.',
    image: '/images/foot-worship.jpg',
  },
  {
    title: 'Sensory Deprivation',
    description: 'Lose yourself in darkness and anticipation.',
    image: '/images/sensory-deprivation.jpg',
  },
  {
    title: 'Spanking & Impact Play',
    description: 'Pain and pleasure blend seamlessly in my hands.',
    image: '/images/spanking.jpg',
  },
  {
    title: 'Feminization & Sissification',
    description:
      'I will transform you into the submissive doll you were meant to be.',
    image: '/images/feminization.jpg',
  },
];
